<div class="calendars-container">
    <div class="banner">
        <div class="title">
            <fa-icon [icon]="faAngleRight"></fa-icon>
            <span>{{ 'Calendars.Title' | translate }}</span>
        </div>

        <div class="action-zone">
            <button color="accent" mat-button routerLink="/calendar">
                {{ 'Calendars.ButtonCalendarCreation' | translate }}
                <mat-icon>add_circle</mat-icon>
            </button>
        </div>
    </div>

    <div class="table-container">
        <form class="filters-form" [formGroup]="filtersForm">
            <div class="mat-elevation-z8">
                <table mat-table [dataSource]="dataSource" matSort>
                    <!-- <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>
            <span mat-sort-header>{{'Calendars.ColumnHeaderId'|translate}}</span>
            <mat-form-field>
              <input matInput formControlName="id" (keyup)="applyFilters()" autocomplete="off"/>
              <button mat-icon-button matSuffix class="header-button" matTooltip="{{ 'Calendars.ResetFilterColumn' | translate }}"
                (click)="resetColumnFilter('id')" type="button">
                <mat-icon>undo</mat-icon>
              </button>
            </mat-form-field>
          </th>
          <td mat-cell *matCellDef="let element"> {{element.id}} </td>
        </ng-container> -->

                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>{{ 'Calendars.ColumnHeaderName' | translate }}</span>
                            <div class="small">
                                <mat-form-field class="form-field" appearance="outline">
                                    <input matInput formControlName="name" (keyup)="applyFilters()" autocomplete="off" />
                                    <button
                                        mat-icon-button
                                        matSuffix
                                        class="mat-accent search-icon"
                                        matTooltip="{{ 'Calendars.ResetFilterColumn' | translate }}"
                                        (click)="resetColumnFilter('name')">
                                        <mat-icon>undo</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{ element.name }}</td>
                    </ng-container>

                    <!-- <ng-container matColumnDef="nextId">
          <th mat-header-cell *matHeaderCellDef>
            <span mat-sort-header>{{'Calendars.ColumnHeaderNextId'|translate}}</span>
            <mat-form-field>
              <input matInput formControlName="nextId" (keyup)="applyFilters()" autocomplete="off"/>
              <button mat-icon-button matSuffix class="header-button" matTooltip="{{ 'Calendars.ResetFilterColumn' | translate }}"
                (click)="resetColumnFilter('nextId')">
                <mat-icon>undo</mat-icon>
              </button>
            </mat-form-field>
          </th>
          <td mat-cell *matCellDef="let element"> {{element.nextId}} </td>
        </ng-container> -->

                    <ng-container matColumnDef="days">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>{{ 'Calendars.ColumnHeaderDays' | translate }}</span>
                            <div class="small">
                                <mat-form-field class="form-field" appearance="outline">
                                    <mat-select formControlName="days" (selectionChange)="applyFilters()" multiple>
                                        @for (day of daysOfWeek; track day) {
                                        <mat-option [value]="day">
                                            {{ 'EnumDaysOfWeek.' + day | translate }}
                                        </mat-option>
                                        }
                                    </mat-select>
                                    <button
                                        mat-icon-button
                                        matSuffix
                                        class="mat-accent search-icon"
                                        matTooltip="{{ 'Calendars.ResetFilterColumn' | translate }}"
                                        (click)="resetColumnFilter('days')"
                                        type="button">
                                        <mat-icon>undo</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.days | daysPipe }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="actions" stickyEnd>
                        <th mat-header-cell *matHeaderCellDef>
                            <button
                                mat-icon-button
                                matSuffix
                                class="header-button"
                                matTooltip="{{ 'Calendars.ResetAllFiltersColumn' | translate }}"
                                (click)="resetAllColumnFilter()">
                                <mat-icon>undo</mat-icon>
                            </button>
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <div class="action-column">
                                <button mat-icon-button routerLink="/calendar" [queryParams]="{ id: element.id }">
                                    <mat-icon>visibility</mat-icon>
                                </button>
                                <button mat-icon-button (click)="onDeleteClick(element.id, element.name)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>

                <mat-paginator [pageSizeOptions]="[25, 50, 100]" class="default-paginator"></mat-paginator>
            </div>
        </form>
    </div>
</div>
